import ApiService, { IRequestParameters } from '@/plugins/api-plugin/services/api.service'
import EmailTemplateSummaryDao from '@/interfaces/admin/EmailTemplateSummary.dao'
import EmailTemplateLookupsDao from '@/interfaces/admin/EmailTemplateLookups.dao'
import EmailTemplateDetailDao from '@/interfaces/admin/EmailTemplateDetail.dao'
import WriteEmailTemplateDao from '@/interfaces/admin/WriteEmailTemplate.dao'
import { SendTestEmailDao, SendTestEmailResultDao } from '@/interfaces/admin/SendTestEmail.dao'
import { PageNumberPagination } from '@/interfaces/common/PageNumberPagination'

export default class EmailTemplatesService extends ApiService {
    async getEmailTemplates(
        params?: IRequestParameters,
    ): Promise<[EmailTemplateSummaryDao[], PageNumberPagination] | null> {
        return this.request<undefined, [EmailTemplateSummaryDao[], PageNumberPagination] | null>(
            'GET',
            '/email-templates',
            params,
            undefined,
            undefined,
            'getEmailTemplates',
        ).catch(() => null)
    }

    async getEmailTemplateLookups(): Promise<EmailTemplateLookupsDao | null> {
        return this.request<undefined, EmailTemplateLookupsDao>(
            'GET',
            '/email-templates/lookups',
            undefined,
            undefined,
            undefined,
            'getEmailTemplateLookups',
        ).catch(() => null)
    }

    async getEmailTemplate(id: number): Promise<EmailTemplateDetailDao | null> {
        return this.request<undefined, EmailTemplateDetailDao>(
            'GET',
            `/email-templates/${id}`,
            undefined,
            undefined,
            undefined,
            'getEmailTemplate',
        ).catch(() => null)
    }

    async createEmailTemplate(dto: WriteEmailTemplateDao): Promise<EmailTemplateDetailDao | null> {
        return this.request<WriteEmailTemplateDao, EmailTemplateDetailDao>(
            'POST',
            '/email-templates',
            undefined,
            dto,
            undefined,
            'createEmailTemplate',
        ).catch(() => null)
    }

    async updateEmailTemplate(id: number, dto: WriteEmailTemplateDao): Promise<EmailTemplateDetailDao | null> {
        return this.request<WriteEmailTemplateDao, EmailTemplateDetailDao>(
            'PUT',
            `/email-templates/${id}`,
            undefined,
            dto,
            undefined,
            'updateEmailTemplate',
        ).catch(() => null)
    }

    async deleteEmailTemplate(id: number): Promise<{ success: true } | null> {
        return this.request<undefined, { success: true }>(
            'DELETE',
            `/email-templates/${id}`,
            undefined,
            undefined,
            undefined,
            'deleteEmailTemplate',
        ).catch(() => null)
    }

    async sendTestEmail(id: number, dto: SendTestEmailDao): Promise<SendTestEmailResultDao | null> {
        return this.request<SendTestEmailDao, SendTestEmailResultDao>(
            'POST',
            `/email-templates/${id}/send-test`,
            undefined,
            dto,
            undefined,
            'sendTestEmail',
        ).catch(() => null)
    }
}
